import type { DemandeRemboursementDTO, LovDrDTO } from '@/features/api/extranet/dto/Demande/DR'
import { EndPointDrDemande, EndPointDrDossier } from '@/features/services'
import { loadDossier } from '../../detail/dossier/DossierService'
import { buildDemandeService } from '../buildDemandeService'

export const drDemandeService = buildDemandeService<'MODEL_DR', LovDrDTO>({
  location: EndPointDrDemande.location,
  normaliserData: normaliserDataDemande,
  loadExtraData: loadExtraDataDemande,
})

export const drDossierService = buildDemandeService<'MODEL_DR', LovDrDTO>({
  location: EndPointDrDossier.location,
  normaliserData: normaliserDataDossier,
  loadExtraData: loadExtraDataDemande,
})

function normaliserDataDemande(data: DemandeRemboursementDTO) {
  //data.typeDemande ??= TypeDemandeDossier
  // S'il n'y a qu'un seul module, force estTraite
  if (data.modules.length === 1) {
    data.modules[0]!.estTraite = true
  }
  data.fichiers ??= []
  data.etablissementAdherentPrincipal ??= {} as any
  data.etablissementAdherentPrincipal!.adresse ??= {} as any
  data.etablissementAdherentPrincipal!.estEtablissementSiege ??= {} as any
  data.etablissementPrincipal ??= {} as any
  data.etablissementPrincipal!.adresse ??= {} as any
  data.financement ??= {} as any
  data.frais ??= []
  return data
}

function normaliserDataDossier(data: DemandeRemboursementDTO) {
  //data.typeDemande ??= TypeDemandeDossier
  // S'il n'y a qu'un seul module, force estTraite
  data.modules ??= []
  if (data.modules?.length === 1) {
    data.modules[0]!.estTraite = true
  }
  data.fichiers ??= []
  data.etablissementAdherentPrincipal ??= {} as any
  data.etablissementAdherentPrincipal!.adresse ??= {} as any
  data.etablissementAdherentPrincipal!.estEtablissementSiege ??= {} as any
  data.etablissementPrincipal ??= {} as any
  data.etablissementPrincipal!.adresse ??= {} as any
  data.financement ??= {} as any
  data.frais ??= []
  return data
}

async function loadExtraDataDemande(data: DemandeRemboursementDTO, init?: RequestInit) {
  //if (data.typeDemande !== 'Remboursement') return data
  if (!data.codeDossier) throw Error('Le code dossier est manquant, impossible de charger le dossier associé.')

  const result = await loadDossier(data.codeDossier, init)

  return {
    ...data,
    dossier: result,
  }
}
